import { useMutation } from "urql";

import { UpdateMeDocument } from "../../../graphql/generated.ts";

export function useUpdateMe() {
  return useMutation(UpdateMeDocument);
}
